import React from 'react';
import Mainpage from "../components/AboutPage/Mainpage";
import {ThemeProvider} from '@mui/material';
import theme from '../style/theme';


function Home() {
    return (
        <ThemeProvider theme={theme}>
            <Mainpage/>
        </ThemeProvider>
    );
}

export default Home;
